import { CircularProgress } from "@mui/material";
import type { ReactNode } from "react";
import { useCanAccess, useTranslate } from "react-admin";
import { Navigate } from "react-router-dom";

import type { PortalResource } from "../auth/access";

type RequirePermissionProps = {
  permission: PortalResource;
  children: ReactNode;
};

export const RequirePermission = ({ permission, children }: RequirePermissionProps) => {
  const { canAccess, isPending } = useCanAccess({ action: "list", resource: permission });
  const translate = useTranslate();
  if (isPending) return <CircularProgress aria-label={translate("learning.permissionCheck")} />;
  if (canAccess !== true) return <Navigate to="/" replace />;
  return <>{children}</>;
};
